import { Suspense } from "react"
import { useTranslation } from "react-i18next"
import { LoadingSpinner } from "@/components/loading-spinner"
import { Drawer, DrawerClose, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui/drawer"
import { FaroInsightsWrapper } from "@/grafana-faro"
import { QuestionnaireContent } from "@/modules/patients/detail/progress-note/components/questionnaire-content"
import { useDrawerStore } from "@/stores/useDrawerStore"
import { CommunicationChannel, QuestionnaireType, RequestType } from "@/types/__generated__/union-types"

interface QuestionnaireDrawerProps {
  completedAt: string
  isReadOnly: boolean
  appointmentId: string
  questionnaireId: number | null
  isCompletedAppointment?: boolean
  channel: CommunicationChannel
  name: string
  type: QuestionnaireType
  requestType?: RequestType
  progressNoteId?: string
  diagnosisCode?: string
}
const QuestionnaireDrawer = ({
  isReadOnly,
  appointmentId,
  questionnaireId,
  isCompletedAppointment,
  channel,
  name,
  type,
  requestType,
  progressNoteId,
  diagnosisCode,
}: QuestionnaireDrawerProps) => {
  const { t } = useTranslation()
  const closeDrawer = useDrawerStore((state) => state.closeDrawer)

  const handleClose = () => {
    FaroInsightsWrapper.pushEvent("questionnaires_close")
    closeDrawer()
  }

  return (
    <Drawer open onOpenChange={handleClose}>
      <DrawerContent data-testid="questionnaires-drawer-content">
        <Suspense fallback={<LoadingSpinner isFullPage={true} size={24} />}>
          <DrawerClose className="top-2 right-2" />
          <DrawerHeader className="py-4.5 pr-4">
            <DrawerTitle
              className="animate-fade-in-bottom text-on-surface-subdued text-sm font-medium"
              data-testid="questionnaires-drawer-title">
              {t("patient.questionnaire.title")}: {name}
            </DrawerTitle>
          </DrawerHeader>
          {questionnaireId && (
            <QuestionnaireContent
              onClose={handleClose}
              isReadOnly={isReadOnly}
              appointmentId={appointmentId}
              questionnaireId={questionnaireId}
              isCompletedAppointment={isCompletedAppointment}
              channel={channel}
              type={type}
              requestType={requestType}
              progressNoteId={progressNoteId}
              diagnosisCode={diagnosisCode}
            />
          )}
        </Suspense>
      </DrawerContent>
    </Drawer>
  )
}

export { QuestionnaireDrawer }
